// extracted by mini-css-extract-plugin
export default {"fullWidth":"qn-z","image":"rn-z","lazyLoadPicture":"sn-z","lazyLoadSpinner":"tn-z","lazyLoadSpin":"un-z","lazyLoadImage":"vn-z","hasStyledAspectRatio":"wn-z"};